<template>
  <form id="formPhysical" class="text-center">
    <v-container>
      <v-row class="pt-6">
        <v-col>
          <h3 class="font-weight-regular">Физичeское лицо</h3>
        </v-col>
      </v-row>
      <v-row class="pt-6">
        <v-col md=6 cols=12>
          <v-text-field
            v-model="fio"
            :error-messages="fioErrors"
            label="ФИО"
            name="fio"
            required
            @input="$v.fio.$touch()"
            @blur="$v.fio.$touch()"
          ></v-text-field>
        </v-col>
        <v-col md=6 cols=12>
          <v-text-field
            v-model="email"
            :error-messages="emailErrors"
            label="Ваш e-mail"
            required
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()"
            name="email"
          ></v-text-field>
        </v-col>
        <v-col md=6 cols=12>
          <v-text-field
            v-model="phone"
            v-mask="phoneMask"
            :error-messages="phoneErrors"
            label="Ваш номер"
            required
            @input="$v.phone.$touch()"
            @blur="$v.phone.$touch()"
            type="tel"
            name="phone"
          ></v-text-field>
        </v-col>
        <v-col md=6 cols=12>
          <v-text-field
            v-model="passport"
            v-mask="passportMask"
            :error-messages="passportErrors"
            label="Серия и номер паспорта"
            required
            @input="$v.passport.$touch()"
            @blur="$v.passport.$touch()"
            type="tel"
            name="passport"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="address"
            :error-messages="addressErrors"
            label="Адрес регистрации"
            required
            @input="$v.address.$touch()"
            @blur="$v.address.$touch()"
            name="address"
          ></v-text-field>
        </v-col>
        <v-col cols=12>
          <v-text-field
            v-model="address2"
            label="* Адрес проживания, если отличается"
            name="address2"
          ></v-text-field>
        </v-col>
        <v-col cols=12 class="checkbox d-flex align-center text-left">
          <v-checkbox
            dark
            id="checkboxPhysical"
            v-model="checkbox"
            label="Согласен с политикой конфиденциальности"
            :error-messages="checkboxErrors"
            required
            @change="$v.checkbox.$touch()"
            @blur="$v.checkbox.$touch()"
          ></v-checkbox>
        </v-col>
        <v-col cols=12 class="mt-12">
          <div class="buttons">
            <v-btn dark color="#13bbec" @click="isActivePhysical = false" v-model="isActivePhysical">Назад</v-btn>
            <v-btn dark color="#13bbec" @click="submit">Отправить</v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row class="pt-6">
        <v-col class="text-center">
          <router-link to="privacy" @click.native="goUp">политика конфиденциальности</router-link>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
  import { mask } from 'vue-the-mask'
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, minLength, email } from 'vuelidate/lib/validators'
  export default {
    name: 'physicalForm',
    props: {
      value: Boolean
    },
    watch : {
      value(newVal){
        this.isActivePhysical = newVal
      },
      isActivePhysical(newVal) {
        this.$emit('input', newVal)
      }
    },
    directives: {mask},
    mixins: [validationMixin],
    validations: {
      fio: { required, maxLength: maxLength(10) },
      email: { required, email },
      phone: { required, minLength: minLength(17) },
      passport: { required, minLength: minLength(11) },
      address: { required },
      checkbox: {
        checked (val) {
          return val
        },
      },
    },
    data: () => (
      {
        fio: '',
        email: '',
        phone: '',
        phoneMask: '# (###) ###-##-##',
        passport: '',
        passportMask: '#### ######',
        address: '',
        address2: '',
        checkbox: false,
        isActivePhysical: true
      }
    ),
    computed: {
      fioErrors () {
        const errors = []
        if (!this.$v.fio.$dirty) return errors
        !this.$v.fio.maxLength && errors.push('Имя не должно содержать более 10 символов')
        !this.$v.fio.required && errors.push('Введите ваше имя')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Введите валидный e-mail')
        !this.$v.email.required && errors.push('Введите ваше сообщение')
        return errors
      },
      phoneErrors () {
        const errors = []
        if (!this.$v.phone.$dirty) return errors
        !this.$v.phone.minLength && errors.push('Ваш номер должен содержать больше 10 цифр')
        !this.$v.phone.required && errors.push('Введите ваш контактный номер')
        return errors
      },
      passportErrors () {
        const errors = []
        if (!this.$v.passport.$dirty) return errors
        !this.$v.passport.minLength && errors.push('Серия и номер должны содержать более 9 цифр')
        !this.$v.passport.required && errors.push('Введите даты поездки')
        return errors
      },
      addressErrors () {
        const errors = []
        if (!this.$v.address.$dirty) return errors
        !this.$v.address.required && errors.push('Введите адрес регистрации')
        return errors
      },
      checkboxErrors () {
        const errors = []
        if (!this.$v.checkbox.$dirty) return errors
        !this.$v.checkbox.checked && errors.push('Вы должны принять соглашение')
        return errors
      }
    },
    methods: {
      goUp: function() {
        window.scrollTo(0,0)
        this.order = false
      },
      submit () {
        this.$v.$touch()
        if (this.$v.$invalid) {
        } else {
          let formData = new FormData(document.forms.formPhysical)
          fetch('mail/send.php', {
            method: 'POST',
            body: formData
          }).then(function(response){
            document.querySelector('#formPhysical').innerHTML = "<h3>Ура! Ваше сообщение отправлено !</h3>"
          }).catch(function(error){
            document.querySelector('#formPhysical').innerHTML = "<h3>Упс... попробуйте еще раз</h3>"
          }) 
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  form {
    width: 50%;
    a {
      color: #13bbec;
      font-size: 90%;
    }
    .col-12 {
      padding: 2px 16px;
    }
    input, label {
      color: #fff !important;
    }
    .v-input__slot:before {
      border-color: #fff !important;
      &:focus {
        border-color: #fff;
      }
    }
    .buttons {
      button {
        margin: 0 1rem;
      }
    }
  }
</style>